
import {
  LeftOutlined,
  RightOutlined,
  FileTextOutlined,
  FormOutlined,
  AuditOutlined,
  CodeOutlined,
  FundProjectionScreenOutlined,
  ToolOutlined,
  CustomerServiceOutlined
} from '@ant-design/icons-vue'
import {
  defineComponent,
  onMounted,
  ref,
  watch,
  h,
  computed,
  onUnmounted
} from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import SwiperCore, { Autoplay } from 'swiper'
import 'swiper/swiper-bundle.css'
import 'swiper/swiper.min.css'
import { getBanners, getCiicLogo } from '../api/api'
SwiperCore.use([Autoplay])

export default defineComponent({
  name: 'Home',
  components: {
    LeftOutlined,
    RightOutlined,
    FileTextOutlined,
    FormOutlined,
    AuditOutlined,
    CodeOutlined,
    FundProjectionScreenOutlined,
    ToolOutlined,
    CustomerServiceOutlined,
    Swiper,
    SwiperSlide
  },
  setup() {
    const screenWidth = ref(0)
    const slidesPerView = ref(7)
    const activeIndex = ref(0)
    const states = ref(0)
    const statestitle = ref(0)
    const dzlcItems = ref([
      {
        title: '01需求调研',
        description: '前期调研，充分了解客户需求',
        icon: h(FileTextOutlined)
      },
      {
        title: '02分析策划',
        description: '分析需求进行功能总结，创意构思，合理脑洞',
        icon: h(FormOutlined)
      },
      {
        title: '03合作签订',
        description: '签订合同，保障双方权益',
        icon: h(AuditOutlined)
      },
      {
        title: '04页面设计',
        description: '一对一设计，让客户满意',
        icon: h(FileTextOutlined)
      },
      {
        title: '05开发与测试',
        description: '资深团队，完善质量管理体系',
        icon: h(CodeOutlined)
      },
      {
        title: '06验收上线',
        description: '客户验收，项目上线',
        icon: h(FundProjectionScreenOutlined)
      },
      {
        title: '07跟踪维护',
        description: '7*24积极维护',
        icon: h(ToolOutlined)
      }
    ])
    const settingWidth = ref(34)
    const settingHeight = ref(34)

    const bannerList = ref<any>([])
    const logoList = ref<any>([])

    // 业务流程步骤数据
    const processSteps = ref([
      { image: require('../assets/img/bz1.png'), alt: '步骤1', style: { top: '20%', left: '5%', zIndex: 9, width: '19%' } },
      { image: require('../assets/img/bz2.png'), alt: '步骤2', style: { top: '-8%', left: '18%', zIndex: 8, width: '19%' } },
      { image: require('../assets/img/bz3.png'), alt: '步骤3', style: { top: '38%', left: '30%', zIndex: 7, width: '19%' } },
      { image: require('../assets/img/bz4.png'), alt: '步骤4', style: { top: '3%', left: '44%', zIndex: 6, width: '19%' } },
      { image: require('../assets/img/bz5.png'), alt: '步骤5', style: { top: '41%', left: '56%', zIndex: 5, width: '19%' } },
      { image: require('../assets/img/bz6.png'), alt: '步骤6', style: { top: '-1%', left: '68%', zIndex: 4, width: '19%' } },
      { image: require('../assets/img/bz7.png'), alt: '步骤7', style: { top: '22%', left: '80%', zIndex: 3, width: '18%' } }
    ])

    const getImageUrl = (prefix: string, index: number) => {
      return require(`../assets/img/${prefix}${index}.png`)
    }
    const sortedBannerList = computed(() => {
      return [...bannerList.value].sort((a, b) => {
        return parseInt(a.sort) - parseInt(b.sort)
      })
    })

    // 处理屏幕尺寸变化的函数
    const updateViewForScreenSize = (width: number) => {
      if (width < 768) {
        states.value = 1
        slidesPerView.value = 1
        statestitle.value = 0 // 移动端重置为 0
      } else {
        states.value = 0
        if (width < 1200) {
          slidesPerView.value = 3
          statestitle.value = 2 // 窄屏桌面端设为 2
        } else if (width < 1300) {
          slidesPerView.value = 5
          statestitle.value = 0 // 中屏桌面端重置为 0
        } else if (width < 1550) {
          slidesPerView.value = 6
          statestitle.value = 0 // 宽屏桌面端重置为 0
        } else {
          slidesPerView.value = 7
          statestitle.value = 0 // 超宽屏桌面端重置为 0
        }
      }

      // 图标大小设置（不变）
      settingWidth.value = width > 768 ? 34 : 26
      settingHeight.value = width > 768 ? 34 : 26

      console.log('Screen width:', width, 'States:', states.value, 'Slides:', slidesPerView.value, 'Statestitle:', statestitle.value)
    }

    // 处理resize事件
    const handleResize = () => {
      screenWidth.value = window.innerWidth
      updateViewForScreenSize(screenWidth.value)
    }

    onMounted(() => {
      // 初始化屏幕宽度
      screenWidth.value = window.innerWidth

      // 初始设置states和slidesPerView
      updateViewForScreenSize(screenWidth.value)

      // 添加resize事件监听
      window.addEventListener('resize', handleResize)

      getBanners().then((res: any) => {
        bannerList.value = res
      })
      getCiicLogo().then((res: any) => {
        logoList.value = res
      })
    })

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize)
    })

    const onChange = (currentSlide: number) => {
      // console.log(currentSlide)
    }
    const showFirstImage = (index: number) => {
      activeIndex.value = index
    }

    return {
      onChange,
      screenWidth,
      LeftOutlined,
      RightOutlined,
      FileTextOutlined,
      FormOutlined,
      AuditOutlined,
      CodeOutlined,
      FundProjectionScreenOutlined,
      ToolOutlined,
      CustomerServiceOutlined,
      slidesPerView,
      Swiper,
      SwiperSlide,
      dzlcItems,
      settingWidth,
      settingHeight,
      bannerList,
      logoList,
      activeIndex,
      showFirstImage,
      getImageUrl,
      sortedBannerList,
      processSteps,
      states,
      statestitle
    }
  }
})
